import { BaseModel } from './base';
import { Role } from './role';

export interface User extends BaseModel {
  avatar?: string;
  email: string;
  password?: string;
  roles: Role[];
  archived: boolean;
  firstName?: string;
  lastName?: string;
  resetPasswordCode?: string;
  newPassword?: string;
  jobTitle?: string;
  testingSolutions?: string;
  deleteReason?: string;
  createdAt: Date;
  lastLogin?: Date;
  isRemoved?: boolean;
  userExists?: boolean;
  testopUserId?: User['id'];
}

export const getFullNameUser = (firstName: string | undefined, lastName: string | undefined, email: string | undefined) => (!firstName && !lastName ? (email || '').split('@')[0] : `${firstName || ''} ${lastName || ''}`.trim());
